import menu from './menu'
import table from './table'

export default {
    status: 'Status',
    key: 'Schlüsselwort',
    name_management_area: 'Name Verwaltungsbereich',
    name_application_area: 'Name Antragsbereich',
    color: 'Farbe',
    model_class: 'Gehört zu',
    sort: 'Sortierung',
    transitions: 'Übergänge',
    set_form_process_status_id: 'Formularstatus',
    set_form_process_status_id_by_management: 'Formularstatus Verwaltungsbereich',
    requires_form_of_type: 'Formulartyp',
    form_data_complete_validation: 'Formularfelder prüfen',
    edit_application_area: 'Felder im Antragsbereich bearbeitbar',
    mail_template_id: 'ID der E-Mail-Vorlage',
    organisation_id: 'ID der Organisation',
    to_user: 'An die Ansprechperson',
    to_organisation: 'An die Kontaktperson des Antragstellers',
    to_association: 'An den Verband',
    to_custom: 'An benutzerdefinierte E-Mail-Adresse',
    to_all: 'An alle',
    notification_mode: 'Benachrichtigungsmodus',

    model_classes: {
        FormProcess: 'Formular',
        Process: 'Maßnahme',
    },

    colors: {
        gray: 'Grau',
        red: 'Rot',
        yellow: 'Gelb',
        green: 'Grün',
        blue: 'Blau',
        indigo: 'Indigo',
        purple: 'Lila',
        pink: 'Pink'
    },

    saveSuccess: 'Status wurde erfolgreich gespeichert.',
    deleteStatus: 'Status löschen',
    deleteStatusText: 'Möchten Sie diesen Status wirklich löschen?',
    deleteStatusSuccess: 'Status wurde erfolgreich gelöscht.',
    deleteStatusError: 'Der Status konnte nicht gelöscht werden.',

    archiveEffect: {
        archives: '{types}: Daten archiviert',
        archivesForm: 'Daten archiviert',
        archivesTooltip: 'Archiviert die Daten des Formulars, sofern sie noch nicht archiviert sind. Spätere Änderungen an Maßnahme, Organisation oder Bankverbindung fließen dann nicht mehr ein. Wechselt das Formular auf einen Status ohne diesen Hinweis, wird die Archivierung aufgehoben.'
    },

    menu,
    table,
}